// extracted by mini-css-extract-plugin
export default {"page":"d0-z","cartModal":"e0-z","checkout":"f0-z","placeholder":"g0-z","account":"h0-z"};